const initialState = null;

export default function UserReducer(state = initialState, action) {
  switch (action.type) {
    case 'PUT_TOKEN':
      return action.token;
    case 'CLEAR_TOKEN':
      return {};
    default:
      return state;
  }
}